import { render } from "./TimelineProposal.vue?vue&type=template&id=fceb83cc"
import script from "./TimelineProposal.vue?vue&type=script&lang=js"
export * from "./TimelineProposal.vue?vue&type=script&lang=js"
script.render = render

export default script